import React, {PropTypes} from 'react'
import cs from 'classnames'
import st from './Cell.scss'

const Cell = (props) => {
	return (
		<div
			{...props}
			className={cs(st.cell, props.className)}
		/>
	)
}
Cell.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
}

export default Cell



// WEBPACK FOOTER //
// ./elements/Cell.jsx